module.exports = __webpack_public_path__ + "static/img/jigou-qingdao-top.99de513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-qingdao-top.png
// module id = 6u/i
// module chunks = 2